module.exports = __webpack_public_path__ + "img/goodlogo.72a6174d.png";